import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeroModule } from 'src/app/shared/components/hero/hero.module';
import { MatExpansionModule } from '@angular/material/expansion';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { AlertModule } from '../../shared/components/alert/alert.module';
import { DevelopmentRoutesComponent } from './routes.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
  imports: [
    CommonModule,
    
    MatAutocompleteModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    HeroModule,
    NgxMaskDirective,
    AlertModule,
    MatExpansionModule,
    MatInputModule,
    MatExpansionModule
  ],
  exports: [
    DevelopmentRoutesComponent
  ],
  providers: [
    provideNgxMask()
  ],
  declarations: [
    DevelopmentRoutesComponent
  ]
})

export class DevelopmentRoutesModule { }
